define([
        'text!./templates/gw-carousel.html',
    ],
    (template) => {
        return [() => ({
            'restrict': 'AE',
            'template': template,
            'transclude': true,
            'replace': true,
            'scope': {
                'interval': '=',
                'wrapSlides': '='
            },
            'controller': ['$scope', '$element', '$transclude', ($scope) => {
                $scope.interval = $scope.interval || 5000;
                $scope.wrapSlides = $scope.wrapSlides || true;
                $scope.activeFn = () => {
                }; //Used to invoke child active slide function.
            }],
        })];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/carousel/directives/GwCarousel.js